import React from 'react'
import { scrollIntoView, scrollTo } from '@superhi/design'

import Page from '../../components/Page'
import { PageConfig } from '../../routing/types'
import MarketingBlockMembership from '../../components/MembershipProductCallout'

import Overview from './components/Overview'
import Contents, { ID as CONTENTS_ID } from './components/Contents'
import { Props } from './data'
import Header from './components/Header'
import ROUTE from './route'

const Guide: PageConfig<Props> = ({
  title,
  seoDescription,
  image,
  description,
  overview,
  posts = [],
  slug,
  downloadUrl,
  mailchimpTag,
  color,
}) => (
  <Page title={title} description={seoDescription} imageUrl={image.url} imageFm="png8">
    <Header
      title={title}
      description={description}
      slug={slug}
      image={image}
      onClickRead={() => scrollTo(CONTENTS_ID)}
      downloadUrl={downloadUrl}
      leadTag={`${mailchimpTag}-downloaded`}
      color={color}
    />

    <Overview items={overview} />

    <Contents
      items={posts.map(({ image, ...post }) => ({
        ...post,
        imageUrl: image.url,
      }))}
    />

    {/* <MarketingBlockMembership noTopPadding /> */}
  </Page>
)

Guide.route = ROUTE

export { getStaticPaths, getStaticProps } from './data'
export default Guide
